const dataFilter = (rows: any[], id: number, filterValue: string) => {
    console.log('data searchfilter')
    return rows.filter(row => {
        const rowValue = row.values[id]
        return filterValue.length === 0 || (rowValue !== undefined && rowValue.props['data-filter'] === filterValue)
    })
}

export default dataFilter